import Backbone from 'backbone';
import ko from 'knockout';

import ViewModel from './viewmodel';
import template from './template.pug';

/* @this PillControl */
function itemClicked(event) {
  this.viewModel.selectedIndex(Number(event.currentTarget.dataset.index));
}

/**
 * The Pill Control view
 */
export class PillControl extends Backbone.View {
  get events() {
    return {
      'click .pill-control a': itemClicked,
    };
  }


  /**
   * The Pill Control view initialize method
   * @param {object[]} items - items to show in the pill control
   * @param {number|string} [items[].id] - indicate the identifier of this item
   * @param {string} items[].text - indicate the showing content of this item
   * @param {value} [items[].value] - indicate the value of this item
   * @param {number} [selectedIndex] - the index of item array to indicate which is selected
   * @returns {void} void
   */
  initialize({
    items,
    selectedIndex = 0,
    tabPanelId = 'child-page',
  }) {
    this.viewModel = new ViewModel({
      items,
      selectedIndex,
      tabPanelId,
    });
    this.viewModel.selected.subscribe((value) => {
      this.trigger('select', {
        item: value,
        index: this.viewModel.selectedIndex(),
      });
    });
  }

  render() {
    this.$el.html(template());
    ko.applyBindings(this.viewModel, this.el);

    return this;
  }

  remove() {
    ko.cleanNode(this.el);

    super.remove();
  }
}
